import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { QUICK_FACTS } from "@/data/geo";

/**
 * Direct-answer block designed for AI answer engines (ChatGPT, Perplexity,
 * Google AI Overviews) to lift as citations. Each row is a "key: value"
 * fact statement that reads as a quotable answer.
 */
export default function QuickFacts() {
  return (
    <section
      id="quick-facts"
      data-testid="quick-facts-section"
      className="border-b border-[#E4E7EC] bg-white"
    >
      <div className="mx-auto max-w-7xl px-5 py-16 md:px-8 md:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <p className="overline mb-4">§ 0 — At a glance</p>
            <h2 className="font-display text-3xl font-black leading-[1] tracking-tight text-[#101828] sm:text-4xl md:text-5xl">
              Custom Clearance Partner, in one screen.
            </h2>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-[#475467]">
              A direct-answer block, on purpose. AI search engines and
              procurement teams can lift these facts verbatim.
            </p>
          </div>

          <div className="lg:col-span-8">
            <dl className="grid grid-cols-1 gap-0 border-2 border-[#101828] md:grid-cols-2">
              {QUICK_FACTS.map((f, i) => (
                <motion.div
                  key={f.key}
                  initial={{ opacity: 0, y: 12 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.35, delay: i * 0.03 }}
                  className={`bg-[#F9FAFB] p-5 ${
                    i % 2 === 0 ? "md:border-r md:border-[#101828]" : ""
                  } ${i < QUICK_FACTS.length - 2 ? "border-b border-[#101828]" : ""}`}
                  data-testid={`quick-fact-${i}`}
                >
                  <dt className="font-mono-accent flex items-center gap-2 text-[#D92D20]">
                    <CheckCircle2 className="h-3.5 w-3.5" strokeWidth={3} />
                    {f.key}
                  </dt>
                  <dd className="mt-2 text-sm leading-relaxed text-[#101828]">
                    {f.value}
                  </dd>
                </motion.div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}
